module.exports = __webpack_public_path__ + "static/media/logo-light.338f5498.png";